import React, { useState } from 'react'
import Container from '../container'
import Datatable from '../datatable/datatable'
import { Link } from 'gatsby'

// import Graph from '../graph/graph';

import * as styles from './cloudIndexStats.module.css'
import * as linkStyle from '../../styles/components/links.module.css'
import Icon from '../icons'

const CloudIndexStats = ({ data }) => {
  const [compare, setCompare] = useState(null)
  const [date, setDate] = useState('April 28, 2023')

  const round = (value, precision) => {
    var multiplier = Math.pow(10, precision || 0)
    return Math.round(value * multiplier) / multiplier
  }

  const updateCompare = (spread = 'all') => {
    const getStartIndex = (nodesLength) => {
      let start = 0
      switch (spread) {
        case '1w':
          start = nodesLength - 7
          break
        case '1m':
          start = nodesLength - 30
          break
        case '3m':
          start = nodesLength - 91
          break
        case '6m':
          start = nodesLength - 183
          break
        case '1y':
          start = nodesLength - 365
          break
        case '3y':
          start = nodesLength - 1095
          break
        default:
          start = 0
      }
      return Math.max(start, 0)
    }

    const formatDate = (dateString) => {
      if (!dateString) return 'N/A'

      const theDate = new Date(dateString.replace(' 16:00:00', ''))
      const months = [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
      ]

      const dateOrdinal = (d) => {
        if (d === 31 || d === 21 || d === 1) return d + 'st'
        if (d === 22 || d === 2) return d + 'nd'
        if (d === 23 || d === 3) return d + 'rd'
        return d + 'th'
      }

      return `${months[theDate.getMonth()]} ${dateOrdinal(theDate.getDate())}, ${theDate.getFullYear()}`
    }

    const getIndexData = (nodes) => {
      if (!nodes || nodes.length === 0) return null

      const lastIndex = nodes.length - 1
      const startIndex = getStartIndex(nodes.length)

      return {
        today: nodes[lastIndex]?.close,
        date: nodes[startIndex]?.close,
        change: nodes[startIndex]?.close
          ? ((nodes[lastIndex]?.close - nodes[startIndex]?.close) / nodes[startIndex]?.close) * 100
          : null
      }
    }

    const dateSource = data.redpoint?.nodes || data.nasdaq?.nodes || data.snp500?.nodes || data.dowjones?.nodes
    const startIndex = dateSource ? getStartIndex(dateSource.length) : 0
    const startDate = dateSource?.[startIndex]?.date
    setDate(formatDate(startDate))

    setCompare({
      redpoint: getIndexData(data.redpoint?.nodes),
      nasdaq: getIndexData(data.nasdaq?.nodes),
      snp500: getIndexData(data.snp500?.nodes),
      dowjones: getIndexData(data.dowjones?.nodes)
    })
  }

  if (compare === null) {
    updateCompare('all')
  }

  return (
    <div className={`${styles.stats} off`}>
      <Container class={styles.container}>
        <p className={styles.intro}>The Nasdaq Redpoint Cloud Infrastructure Software Index&trade; is designed to track the performance of a selection of companies that derive the majority of its revenue from selling cloud-native infrastructure software.</p>
        <div className={styles.callouts}>
          <div>
            <span className={styles.statValue}>{data.settings.nodes[0].totalMarketCap}</span>
            <span className={styles.statDescription}>Total Market Cap</span>
          </div>
          {/* <div>
                        <span className={styles.statValue}>{data.settings.nodes[0].medianRevenueMultiple}</span>
                        <span className={styles.statMarker}></span>
                        <span className={styles.statDescription}>Median Revenue Multiple</span>
                    </div> */}
          <div>
            <span className={styles.statValue}>{data.settings.nodes[0].medianRevenueGrowthRate}</span>
            <span className={styles.statDescription}>Median Revenue Growth Rate</span>
          </div>
        </div>

        {compare && (
          <Datatable
            topPad
            title='Compare'
            headers={[
              'Index',
              'Today',
              'Date',
              'Change'
            ]}
            date={date}
            update={updateCompare}
            rows={[
              { Index: 'NQRPCI', Today: `${compare.redpoint.today.toLocaleString('en-US')}`, Date: `${compare.redpoint.date.toLocaleString('en-US')}`, Change: `${round(compare.redpoint.change, 1)}%` },
              { Index: 'NASDAQ', Today: `${compare.nasdaq.today.toLocaleString('en-US')}`, Date: `${compare.nasdaq.date.toLocaleString('en-US')}`, Change: `${round(compare.nasdaq.change, 1)}%` },
              { Index: 'S&P 500', Today: `${compare.snp500.today.toLocaleString('en-US')}`, Date: `${compare.snp500.date.toLocaleString('en-US')}`, Change: `${round(compare.snp500.change, 1)}%` },
              { Index: 'DOW JONES', Today: `${compare.dowjones.today.toLocaleString('en-US')}`, Date: `${compare.dowjones.date.toLocaleString('en-US')}`, Change: `${round(compare.dowjones.change, 1)}%` }
            ]}
          />
        )}

        {/* <Graph
                    topPad={true}
                    title="Key Cloud Index Metrics"
                    yAxis={[
                        "Forward Revenue Multiple",
                        "Revenue Multiple",
                        "Revenue Growth Rate",
                        "Efficiency Score",
                        "LTM FCF Margin",
                        "Gross Margin"
                    ]}
                    trackItems={[
                        {color: "rpb", label: "Median"},
                        {color: "mrb", label: "Top Quartile"},
                        {color: "dbb", label: "Bottom Quartile"},
                    ]}
                    fineprint={["Lipsum"]}
                /> */}

        <div className={styles.banner}>
          <span className={styles.bannerText}>Read the</span> <span className={styles.bannerText}>InfraRed Report</span>
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Link className={linkStyle.linkArrow} to='/infrared/report/'>View Report
              <span>
                <div className={linkStyle.iconCircle} />
                <div className={linkStyle.icon}>
                  <Icon symbol='newsArrowIcon' color='currentColor' />
                </div>
                <div className={linkStyle.iconSecondary}>
                  <Icon symbol='newsArrowIcon' color='currentColor' />
                </div>
              </span>
            </Link>
          </div>
        </div>
      </Container>
    </div>
  )
}

export default CloudIndexStats
